module.exports = __webpack_public_path__ + "img/header-memoireRingsGrowingMemoires.02fc57e.webp";